import {
  fieldStaticIPRequired,
  fieldQualifiedSpeed,
  fieldTerm,
  fieldRegularMonthlyOffers,
  fieldRegularYearlyOffers,
  fieldTwoMonthsDuration,
  fieldLimitedTimeOffer,
  fieldLimitedTimeBasicOffer,
  twoMonthsDuration,
  fiveYearlyCopperPromos,
  fiveDollarsOff,
  BACKEND_KEYS,
  numberTelusWifiAccessPointsCopper,
  sixMonthsFree,
  valueTerm60Month,
  sixMonthsFreePromo,
  switchCreditCopper,
  switchCreditValue
} from '../../../utils/constant';
import { getLocalizedStrings, getLocale } from '../../../misc';
import { internetCopperRates } from '../../businessLogic/rates';
import getFieldValue from './getFieldValue';
import { getFieldPriceOrLabel } from './secureBusiness';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

export default (fields, steps) => {
  const {
    contentfulValues: {
      yes,
      yearsTerm,
      fiveYearsTerm,
      officeInternetBasicPromo,
      officeInternetEnhancedPromo,
      threeMonthsFree,
      bundled,
      monthly,
      monthPromo
    }
  } = getLocalizedStrings();
  const locale = getLocale();
  const {
    WLS: { _valueCopperStaticIpSubnet1, _valueCopperStaticIpSubnet5, _bundled }
  } = locale === 'en-US' ? EN : FR;
  const {
    fields: { formStepFields }
  } = steps.find(
    s => s.fields.backendKey === BACKEND_KEYS.officeInternetCopper
  );

  let staticIPRate = 0;
  let speedRate;
  let promoDiscount = 0;
  let wifiAccessMonthly = 0;
  let wifiAccessOneTime = 0;
  const product = {
    limitedTimeOffers: [],
    fiveYearlyPromo: [],
    regularOffers: [],
    wifiAccess: [],
    switchCreditPromo: []
  };
  const valueStaticIP = getFieldValue(fieldStaticIPRequired, fields);
  const valueQualifiedSpeed = getFieldValue(fieldQualifiedSpeed, fields);

  const valueTerm = getFieldValue(fieldTerm, fields);
  const valueRegularMonthlyPromo = getFieldValue(
    fieldRegularMonthlyOffers,
    fields
  );
  const valueRegularYearlyPromo = getFieldValue(
    fieldRegularYearlyOffers,
    fields
  );
  const switchCreditPromoValue = getFieldValue(
    switchCreditCopper,
    fields
  );
  const valueTwoMonthsPromo = getFieldValue(fieldTwoMonthsDuration, fields);
  const valueLimitedOffer = getFieldValue(fieldLimitedTimeOffer, fields);
  const valueLimitedBasicOffer = getFieldValue(
    fieldLimitedTimeBasicOffer,
    fields
  );
  const valueNumberTelusWifiAccessPoints = getFieldValue(
    numberTelusWifiAccessPointsCopper,
    fields
  );
  const valueTelusPublicWifiFibre = getFieldValue(
    'publicWifi',
    fields
  );
  const fiveYearlyPromosValue = getFieldValue(
    fiveYearlyCopperPromos,
    fields
  );
  const isPromotionIncluded = (limitedOffer, promotion) => {
    return (
      limitedOffer && limitedOffer.length && limitedOffer.includes(promotion)
    );
  };

  const {
    monthlyRates,
    yearlyRates,
    fiveYearlyRates,
    regularOffers: {
      monthPromo: regularMonthlyPromos,
      yearlyPromo: regularYearlyPromos
    },
    limitedBasicOffers,
    limitedEnhancedOffers
  } = internetCopperRates;

  if (valueStaticIP === _valueCopperStaticIpSubnet1) {
    staticIPRate = internetCopperRates[_valueCopperStaticIpSubnet1];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  if (valueStaticIP === _valueCopperStaticIpSubnet5) {
    staticIPRate = internetCopperRates[_valueCopperStaticIpSubnet5];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  if (valueTelusPublicWifiFibre !== yes) {
    if (valueNumberTelusWifiAccessPoints > 0) {
      product.wifiAccess.push({
        value: getFieldPriceOrLabel(formStepFields, numberTelusWifiAccessPointsCopper, false),
        qty: valueNumberTelusWifiAccessPoints,
        prices: {
          monthly: +(valueNumberTelusWifiAccessPoints * 15),
          oneTime: 0
        }
      })
    }
  } else {
    product.wifiAccess = [];
    wifiAccessMonthly = 0;
    wifiAccessOneTime = 0;
  }

  if (valueTerm === monthly) {
    if (valueQualifiedSpeed) {
      speedRate = monthlyRates[valueQualifiedSpeed];

      if (
        valueRegularMonthlyPromo === monthPromo &&
        valueTwoMonthsPromo !== yes &&
        !isPromotionIncluded(valueLimitedOffer, threeMonthsFree) &&
        !isPromotionIncluded(valueLimitedBasicOffer, threeMonthsFree)
      ) {
        product.regularOffers.push({
          value: getFieldPriceOrLabel(formStepFields, monthPromo, false),
          qty: 1,
          prices: {
            monthly: -regularMonthlyPromos[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += regularMonthlyPromos[valueQualifiedSpeed];
      }

      if (
        valueTwoMonthsPromo === yes ||
        isPromotionIncluded(valueLimitedOffer, threeMonthsFree) ||
        isPromotionIncluded(valueLimitedBasicOffer, threeMonthsFree)
      ) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(formStepFields, threeMonthsFree, false),
          qty: 1,
          prices: {
            monthly: -monthlyRates[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += monthlyRates[valueQualifiedSpeed];
      }
      if (fields.twoMonthsDuration && fields.twoMonthsDuration === yes) {
        product.regularOffers.push({
          value: getFieldPriceOrLabel(formStepFields, twoMonthsDuration, false),
          qty: 1,
          prices: {
            monthly: -monthlyRates[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += monthlyRates[valueQualifiedSpeed];
      }
      if (
        isPromotionIncluded(valueLimitedOffer, officeInternetBasicPromo) ||
        isPromotionIncluded(valueLimitedBasicOffer, officeInternetBasicPromo)
      ) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            officeInternetBasicPromo,
            false
          ),
          qty: 1,
          prices: {
            monthly: -limitedBasicOffers[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += limitedBasicOffers[valueQualifiedSpeed];
      }
      if (
        isPromotionIncluded(valueLimitedOffer, officeInternetEnhancedPromo) ||
        isPromotionIncluded(valueLimitedBasicOffer, officeInternetEnhancedPromo)
      ) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            officeInternetEnhancedPromo,
            false
          ),
          qty: 1,
          prices: {
            monthly: -limitedBasicOffers[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += limitedEnhancedOffers[valueQualifiedSpeed];
      }
    }
  }
  if (valueTerm === yearsTerm || valueTerm === fiveYearsTerm) {
    const yearlyKey = valueTerm === yearsTerm ? yearlyRates : fiveYearlyRates;
    if (valueQualifiedSpeed) {
      speedRate = yearlyKey[valueQualifiedSpeed];
    }
    if (
      isPromotionIncluded(valueLimitedOffer, officeInternetBasicPromo) ||
      isPromotionIncluded(valueLimitedBasicOffer, officeInternetBasicPromo)
    ) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          officeInternetBasicPromo,
          false
        ),
        qty: 1,
        prices: {
          monthly: -limitedBasicOffers[valueQualifiedSpeed],
          oneTime: 0
        }
      });
      promoDiscount += limitedBasicOffers[valueQualifiedSpeed];
    }
    if (valueRegularYearlyPromo === _bundled) {
      product.regularOffers.push({
        value: getFieldPriceOrLabel(formStepFields, _bundled, false),
        qty: 1,
        prices: {
          monthly: -regularYearlyPromos[valueQualifiedSpeed],
          oneTime: 0
        }
      });
      promoDiscount += regularYearlyPromos[valueQualifiedSpeed];
    }
    if (fiveYearlyPromosValue === fiveDollarsOff) {
      // remove 5 dollars here
      product.fiveYearlyPromo.push({
        value: fiveDollarsOff,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });
      promoDiscount += 5;
    }
  }
  if (fiveYearlyPromosValue === sixMonthsFreePromo) {
    product.fiveYearlyPromo.push({
      value: sixMonthsFreePromo,
      qty: 1,
      prices: {
        monthly: 0,
        oneTime: 0,
      }
    });
  }
  //Switch Credit $100 Promo Copper
  if (valueRegularYearlyPromo && switchCreditPromoValue === switchCreditValue) {
    product.switchCreditPromo.push({
      value: "$100 Switch Credit ",
      qty: '',
      prices: {
        monthly: '',
        oneTime: '',
      }
    });
  }
  promoDiscount = promoDiscount || 0;
  product.speed = {
    value: getFieldPriceOrLabel(formStepFields, valueQualifiedSpeed, false),
    qty: 1,
    prices: {
      monthly: speedRate,
      oneTime: 0
    }
  };

  product.wifiAccess.forEach(item => {
    wifiAccessMonthly = wifiAccessMonthly + item.prices.monthly;
    wifiAccessOneTime = wifiAccessOneTime + item.prices.oneTime;
  })

  return {
    ...product,
    totalMonthly:
      staticIPRate +
      speedRate - promoDiscount > 0
        ? wifiAccessMonthly + staticIPRate + speedRate - promoDiscount
        : wifiAccessMonthly + staticIPRate,
    totalOneTime: wifiAccessOneTime
  };
};
